<template>
  <div class="header_container">
    <div v-if="this.existImg == true" class="text-center">
      <img :src="this.imgPath" class='golf_course_img'/>
    </div>
  </div>
</template>

<script>
import { GET_GOLFCOURSE } from '../../constants/golf_course'

export default {
    components: {
    },
    props:["reserveData"],
    data () {
        return {
            // ゴルフ場画像css
            reserveHeader: 'reserve_head_border',
            // ゴルフ場画像css切り替えスイッチ
            existImg: false,
            // ゴルフ場画像パス
            imgPath: null,
            // ゴルフ場住所
            golfCourseAddress: null,
            // ゴルフ場名
            golfCourseName: null
        };
    },
    created () {
        this.initialize();
    },
    computed: {
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function () {
            this.GetGolfCourse();
        },
        /** ----------------------------------------------
         * ゴルフ場名および住所取得
         * ---------------------------------------------- */
        GetGolfCourse: function () {
            var golfCourseCode = this.reserveData.golfCode;
            this.$apollo.mutate({
                mutation: GET_GOLFCOURSE,
                variables: {
                    golf_group_code: process.env.MIX_GROUP_CODE,
                    golf_code: golfCourseCode,
                }
            }).then(res => {
                 var GolfCourseDate = res.data.getGolfCourse[0];
                 this.golfCourseName = GolfCourseDate.golf_name;
                 // 住所編集
                 var prefectureName = (GolfCourseDate.prefecture_name == null) ? '' : GolfCourseDate.prefecture_name ;
                 var municipalityName = (GolfCourseDate.municipality_name == null) ? '' : GolfCourseDate.municipality_name;
                 var localName = (GolfCourseDate.local_name == null) ? '' : GolfCourseDate.local_name;
                 var buildingName = (GolfCourseDate.building_name == null) ? '' : GolfCourseDate.building_name;
                 this.imgPath = GolfCourseDate.golf_course_img_path;
                 this.golfCourseAddress = prefectureName + municipalityName + localName + ' ' + buildingName;

                 if ( this.imgPath.trim().length !== 0 ) {
                     this.reserveHeader = 'reserve_head';
                     this.existImg = true;
                 } else {
                     this.reserveHeader = 'reserve_head_border';
                     this.existImg = false;
                 }
                 this.$emit('finished-proc', true);
            }).catch(error => {
                this.error = error;
                this.$emit('finished-proc', false);
            });
        },
    }
}

</script>
